/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Dropdown option for the admin challenge-filter on the draw logs page.
 * @export
 * @interface ChallengeDrawLogsChallengeOption
 */
export interface ChallengeDrawLogsChallengeOption {
    /**
     * 
     * @type {string}
     * @memberof ChallengeDrawLogsChallengeOption
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeDrawLogsChallengeOption
     */
    name?: string;
}

/**
 * Check if a given object implements the ChallengeDrawLogsChallengeOption interface.
 */
export function instanceOfChallengeDrawLogsChallengeOption(value: object): value is ChallengeDrawLogsChallengeOption {
    return true;
}

export function ChallengeDrawLogsChallengeOptionFromJSON(json: any): ChallengeDrawLogsChallengeOption {
    return ChallengeDrawLogsChallengeOptionFromJSONTyped(json, false);
}

export function ChallengeDrawLogsChallengeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeDrawLogsChallengeOption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ChallengeDrawLogsChallengeOptionToJSON(json: any): ChallengeDrawLogsChallengeOption {
    return ChallengeDrawLogsChallengeOptionToJSONTyped(json, false);
}

export function ChallengeDrawLogsChallengeOptionToJSONTyped(value?: ChallengeDrawLogsChallengeOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

